import React from 'react'

import authTokenCookie from '../../api/auth/cookie'
import Page from '../../components/Page'
import { PageConfig } from '../../routing'
import { redirectExternal } from '../../components/RedirectExternal'
import { MARKETING_SITE_URL } from '../../config'
import events from '../../events'
import PageLayout from '../../components/PageLayout'
import redirectExternalUtils from '../../components/RedirectExternal/utils'

import ROUTE, { PathArgs } from './route'

const LogOut: PageConfig<unknown, PathArgs> = () => {
  React.useEffect(() => {
    authTokenCookie.remove()
    events.loggedOut()
    redirectExternal(redirectExternalUtils.get() || MARKETING_SITE_URL, 1000)
  }, [])

  return (
    <Page title="Log out">
      <PageLayout title="Logging out..." />
    </Page>
  )
}

LogOut.route = ROUTE

export default LogOut
